import LocalHospitalIcon from '@mui/icons-material/LocalHospital';
import DescriptionIcon from '@mui/icons-material/Description';
import EventIcon from '@mui/icons-material/Event';

import { WizardStep } from 'components/shared/WizardStepper';

export type PEStepSlug = 'plan-type' | 'plan-details' | 'summary';
const wizardSteps: Map<PEStepSlug, WizardStep> = new Map([
  [
    'plan-type',
    {
      icon: LocalHospitalIcon,
      label: 'Plan Type',
      slug: 'plan-type',
      next: 'plan-details',
    },
  ],
  [
    'plan-details',
    {
      icon: EventIcon,
      label: 'Plan Details',
      slug: 'plan-details',
      next: 'summary',
      prev: 'plan-type',
    },
  ],
  [
    'summary',
    {
      icon: DescriptionIcon,
      label: 'Summary',
      slug: 'summary',
      prev: 'plan-details',
    },
  ],
]);

export default wizardSteps;
